import PropTypes from 'prop-types'
import cx from 'classnames'
import { Modal } from '@material-ui/core'

import styles from './ResetDeviceModal.module.scss'

const ResetDeviceModal = ({ deviceName, hideModal, isCancelReset, onConfirm }) => {
  const actionLabel = isCancelReset ? 'CANCELAR RESET' : 'RESETEAR'
  const message = isCancelReset
    ? `¿Estás seguro de que quieres cancelar el reset del dispositivo ${deviceName}?`
    : `¿Estás seguro de que quieres resetear el dispositivo ${deviceName}?`

  const handleConfirm = () => {
    hideModal()
    onConfirm()
  }

  return (
    <Modal
      open
      onClose={hideModal}
    >
      <div className={styles.overlay}>
        <div
          className={styles.modal}
          data-node-id='1:218'
        >
          <h2 className={styles.title}>Aviso</h2>
          <p className={styles.message}>{message}</p>
          {isCancelReset && (
            <p className={styles.note}>
              Si el dispositivo ya la ha procesado, puede que no sea posible detenerla.
            </p>
          )}
          <div className={styles.actions}>
            <button
              className={styles.cancelButton}
              onClick={hideModal}
              type='button'
            >
              CANCELAR
            </button>
            <button
              className={cx(styles.confirmButton, isCancelReset && styles.cancelResetButton)}
              onClick={handleConfirm}
              type='button'
            >
              {actionLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ResetDeviceModal.propTypes = {
  deviceName: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
  isCancelReset: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ResetDeviceModal
